import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=f88f5012&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoPopup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=f88f5012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88f5012",
  null
  
)

export default component.exports